<template>
    <section class="video-section d-none">
        <div class="container">
            <div class="video-header text-center mb-2">
            </div>
            
            <div class="row justify-content-center">
                <div class="col-lg-10 col-xl-8">
                    <div class="video-container mb-4">
                        <!-- Image thumbnail visible par défaut -->
                        <div class="video-placeholder" id="videoPlaceholder">
                            <img src="@/assets/images/a.png" alt="Tutoriel neolink" class="placeholder-image">
                            <div class="loading-overlay">
                                <div class="play-button">
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                                        <circle cx="32" cy="32" r="32" fill="rgba(255,255,255,0.9)"/>
                                        <path d="M26 20L46 32L26 44V20Z" fill="#1a1a1a"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <!-- Iframe YouTube (caché au début) -->
                        <iframe 
                            class="video-iframe"
                            src="https://www.youtube.com/embed/Th0wmp1nl-s?start=62"
                            :title="t('product.video.title')"
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            allowfullscreen
                            @load="hideVideoPlaceholder"
                            style="opacity: 0;">
                        </iframe>
                    </div>
                    
                    <div class="video-cta text-center ">
                        <router-link to="/inscription" class="btn btn-primary d-none btn-lg me-3 mb-3">
                            {{ t('product.button.start') }}
                        </router-link>
                        <a href="https://m.youtube.com/watch?v=Th0wmp1nl-s&t=62s" target="_blank" class="btn btn-outline-secondary btn-lg mb-3">
                            {{ t('product.button.youtube') }}
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>
<script>

import { useTranslation } from '@/composables/useTranslation'

export default {
    name: 'ProductSection',
     setup() {
        const { t } = useTranslation()
        return { t }
    },
    methods: {
        hideVideoPlaceholder() {
            const placeholder = document.getElementById('videoPlaceholder');
            const iframe = document.querySelector('.video-iframe');
            
            if (placeholder && iframe) {
                // Cacher la thumbnail
                placeholder.style.opacity = '0';
                // Montrer la vidéo
                iframe.style.opacity = '1';
                
                setTimeout(() => {
                    placeholder.style.display = 'none';
                }, 300);
            }
        }
    },
    mounted() {
        // Fallback: cacher le placeholder après 4 secondes si la vidéo ne se charge pas
        setTimeout(() => {
            const placeholder = document.getElementById('videoPlaceholder');
            if (placeholder && placeholder.style.display !== 'none') {
                this.hideVideoPlaceholder();
            }
        }, 4000);
    }
}
</script>

<style lang="scss" scoped>
/* Video Section - Design Minimaliste Noir & Blanc */
.video-section {
    padding: 2rem 0;  // Réduit de 6rem à 2rem
    background: #ffffff;
    color: #1a1a1a;
}

.video-header {
    margin-bottom: 4rem;
    
    h2 {
        font-size: 2.5rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 0;
        letter-spacing: -0.02em;
        line-height: 1.3;
    }
}

.video-container {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    background: #000000;
    
    &:hover {
        box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
    }
}

.video-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    transition: opacity 0.3s ease;
}

.placeholder-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}

.play-button {
    cursor: pointer;
    transition: transform 0.3s ease;
    
    &:hover {
        transform: scale(1.1);
    }
    
    svg {
        filter: drop-shadow(0 4px 8px rgba(0,0,0,0.2));
    }
}

.video-iframe {
    width: 100%;
    height: 400px;
    border: 0;
    transition: opacity 0.3s ease;
}

.video-cta {
    margin-top: 2rem;
    
    .btn {
        padding: 0.875rem 2rem;
        font-weight: 600;
        border-radius: 4px;
        transition: all 0.3s ease;
        text-decoration: none;
        font-size: 0.95rem;
        border: 2px solid transparent;
        display: inline-block;
    }
    
    .btn-primary {
        background: #1a1a1a;
        color: #ffffff;
        border-color: #1a1a1a;
        
        &:hover {
            background: #333333;
            border-color: #333333;
            transform: translateY(-2px);
        }
    }
    
    .btn-outline-secondary {
        background: transparent;
        color: #1a1a1a;
        border-color: #e0e0e0;
        
        &:hover {
            background: #f8f9fa;
            border-color: #1a1a1a;
        }
    }
}

.video-benefits {
    margin-top: 5rem;
    padding-top: 3rem;
    border-top: 1px solid #e0e0e0;
}

.benefit-icon {
    margin-bottom: 1.5rem;
    color: #1a1a1a;
    
    svg {
        transition: all 0.3s ease;
    }
}

.video-benefits .col-md-4:hover .benefit-icon svg {
    transform: scale(1.05);
}

.video-benefits h5 {
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #1a1a1a;
    font-size: 1.1rem;
}

.video-benefits p {
    color: #666666;
    font-size: 0.9rem;
    line-height: 1.5;
    margin: 0;
}

/* Responsive Design */
@media (max-width: 1200px) {
    .video-iframe {
        height: 350px;
    }
}

@media (max-width: 992px) {
    .video-section {
        padding: 1.5rem 0;  // Réduit aussi sur tablet
    }
    
    .video-header h2 {
        font-size: 2rem;
    }
    
    .video-iframe {
        height: 300px;
    }
    
    .video-benefits {
        margin-top: 3rem;
    }
}

@media (max-width: 768px) {
    .video-section {
        padding: 1rem 0;  // Encore plus réduit sur mobile
    }
    
    .video-header {
        margin-bottom: 1rem;  // Réduit la marge du header
        
        h2.lead {
            font-size: 1rem;
        }
    }
    
    .video-iframe {
        height: 250px;
    }
    
    .video-cta {
        .btn {
            display: block;
            width: 100%;
            margin-bottom: 1rem;
            
            &:last-child {
                margin-bottom: 0;
            }
        }
        
        .me-3 {
            margin-right: 0 !important;
        }
    }
    
    .video-benefits {
        margin-top: 2rem;
        padding-top: 2rem;
    }
    
    .play-button svg {
        width: 48px;
        height: 48px;
    }
}

@media (max-width: 480px) {
    .video-header h2 {
        font-size: 1.5rem;
    }
    
    .video-iframe {
        height: 200px;
    }
    
    .btn {
        padding: 0.75rem 1.5rem !important;
        font-size: 0.9rem !important;
    }
    
    .play-button svg {
        width: 40px;
        height: 40px;
    }
}

@import '@/assets/styles/main.scss';
</style>